module.exports = __webpack_public_path__ + "img/logo-biometrix2.642d22bf.png";